import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SecurityAssessmentModal from '../components/SecurityAssessmentModal';
import ConsultationModal from '../components/ConsultationModal';
import DemoModal from '../components/DemoModal';
import Services from '../components/Services';
import Solutions from '../components/Solutions';
import ClientsBanner from '../components/ClientsBanner';
import PartnersBanner from '../components/PartnersBanner';
import Stats from '../components/Stats';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import LoadingScreen from '../components/LoadingScreen';

const HomePage: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAssessmentModalOpen, setIsAssessmentModalOpen] = useState(false);
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Simulate loading time
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
      // Add loaded class to html after loading is complete
      document.documentElement.classList.add('loaded');
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  // Show loading screen
  if (isLoading) {
    return (
      <React.Suspense fallback={
        <div className="loading-screen flex items-center justify-center">
          <div className="text-white">Loading...</div>
        </div>
      }>
        <LoadingScreen />
      </React.Suspense>
    );
  }

  return (
    <React.Suspense fallback={
      <div className="loading-screen flex items-center justify-center">
        <div className="text-white">Loading CyberSoft...</div>
      </div>
    }>
      <div className={`min-h-screen transition-colors duration-300 ${
        isDarkMode ? 'bg-slate-950' : 'bg-slate-50'
      }`}>
        <Header 
          isMenuOpen={isMenuOpen} 
          setIsMenuOpen={setIsMenuOpen}
          isDarkMode={isDarkMode}
          toggleDarkMode={() => setIsDarkMode(!isDarkMode)}
        />
        <Hero 
          onSecurityAssessmentClick={() => setIsAssessmentModalOpen(true)}
          isDarkMode={isDarkMode}
        />
        <SecurityAssessmentModal 
          isOpen={isAssessmentModalOpen} 
          onClose={() => setIsAssessmentModalOpen(false)} 
        />
        <ConsultationModal 
          isOpen={isConsultationModalOpen} 
          onClose={() => setIsConsultationModalOpen(false)} 
        />
        <DemoModal 
          isOpen={isDemoModalOpen} 
          onClose={() => setIsDemoModalOpen(false)} 
        />
        <Services isDarkMode={isDarkMode} />
        <Solutions isDarkMode={isDarkMode} />
        <ClientsBanner />
        <PartnersBanner />
        <Stats />
        <About isDarkMode={isDarkMode} />
        <Contact isDarkMode={isDarkMode} />
        <Footer 
          onConsultationClick={() => setIsConsultationModalOpen(true)}
          onDemoClick={() => setIsDemoModalOpen(true)}
          isDarkMode={isDarkMode}
        />
      </div>
    </React.Suspense>
  );
};

export default HomePage;